import React, { useRef, useState, useEffect } from "react";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import DropDown2 from "../CreateQuestionsPaper/TestScheduling/Dropdwon-Shuffle";
import SelectedDropdownValues from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import InputComponent from "../../Components/Shared/FormInputs/FormInputs";
import { FULL_API_BASE_URL } from "../../Config/Config";
import introgativeImgBlue from "../../Assets/Images/CommanImages/IntrogativeBlue.png";
import DateComponent from "../CreateQuestionsPaper/TestScheduling/DateComponent";
import CalenderImg from "../../Assets/Images/CommanImages/CalenderImg.png";
import TextEditor from "../Landing/components/TextEditor";
import MultiSelectSearchDropdown from "../CreateQuestionsPaper/SearchDropDown/MultiSelectSearchDropdown";
import MultiSelectSearchDropdown2 from "../CreateQuestionsPaper/TestScheduling/Mulit-Dropdwon";
import MultiSelectSearchDropdown3 from "../CreateQuestionsPaper/TestScheduling/MulitSelectDropDown3";
import MinusImg from "../../Assets/Images/CommanImages/MinusGrey.png";
import SuccessImg from "../../Assets/Images/CommanImages/success.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import Colors from "../../Constants/Colors";
import ReflectDropdown from "../../Components/ReflectDropdown/ReflectDropdwon";
import { useNavigate } from "react-router-dom";
import QuickFileUpload from "./QuickFileUpload";

const QuickTestScheduling = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) => {
  const navigate = useNavigate();

  const [testSeriesPrefix, setTestSeriesPrefix] = useState("");
  const [testNameUserPart, setTestNameUserPart] = useState("");
  const [testDescription, setTestDescription] = useState("");
  const [scopeSpecificData, setScopeSpecificData] = useState([]);
  const [scopeSelection, setScopeSelection] = useState([]);
  const [shuffleSubjects, setShuffleSubjects] = useState(0);
  const [shuffleQuestions, setShuffleQuestions] = useState(1);
  const [shuffleOptions, setShuffleOptions] = useState(0);
  const [markingSchemeList, setMarkingSchemeList] = useState([]);
  const [markingSchemeCount, setMarkingSchemeCount] = useState(1);
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [paperSubjects, setPaperSubjects] = useState([]);
  const [showMarkingScheme, setShowMarkingScheme] = useState(false);
  const [testSeriesSubjects, setTestSeriesSubjects] = useState("");
  const [testSeriesDescription, setTestSeriesDescription] = useState("");
  const [numberOfSets, setNumberOfSets] = useState(1);
  const [subjects, setSubjects] = useState("");
  const [selectedTestSeries, setSelectedTestSeries] = useState(null);
  const [testSeries, setTestSeries] = useState([]);
  const [testStartDate, setTestStartDate] = useState(null);
  const [testEndDate, setTestEndDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [scopes, setScopes] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [CordinatorName, setCordinatorName] = useState("Shashi,Parser");
  const [testMode, setTestMode] = useState(1);
  const normalizedTestMode = testMode !== null ? Number(testMode) : "";
  const [testSearchKey, setTestSearchKey] = useState("");
  const [sessionOptions, setSessionOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [allScopeData, setAllScopeData] = useState([]);
  const [testTemplates, setTestTemplates] = useState([]);
  const accessToken = localStorage.getItem("other");
  const [time, setTime] = useState("");
  const [timeMinutes, setTimeMinutes] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [selectScope, setSelectedScope] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [testName, setTestName] = useState(null);
  const [formData, setFormData] = useState({});
  const [testNames, setTestNames] = useState([]);
  const [facultyList, setFacultyList] = useState([]);
  const [testCoordinator, setTestCoordinator] = useState(null);
  const [quesPaperList, setQuesPaperList] = useState([]);
  const [selectedQuesPaper, setSelectedQuesPaper] = useState(null);
  const [quesPaperDescription, setQuesPaperDescription] = useState("");
  const [quesPaperCreatedBy, setQuesPaperCreatedBy] = useState("");
  const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState(
    Array(markingSchemeCount).fill(null)
  );

  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [studentGroupsLoading, setStudentGroupsLoading] = useState(false);
  const [studentGroupsError, setStudentGroupsError] = useState(null);

  const [bodyVisible, setBodyVisible] = useState(true);
  const [schedulingVisible, setSchedulingVisible] = useState(true);
  const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);
  const [isOpenUpload, setIsOpenUpload] = useState(true);
  const [uploadedFile, setUploadedFile] = useState(null);

  const [scopeRefNames, setscopeRefNames] = useState("");
  const [serverCurrentTime, setServerCurrentTime] = useState(null);

  const [testCenterName, setTestCenterName] = useState("");
  const [centerAddress, setCenterAddress] = useState("");
  const [centerCapacity, setCenterCapacity] = useState("");
  const [centerIncharge, setCenterIncharge] = useState(null);
  const [shiftSlot, setShiftSlot] = useState(null);

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  // ── Fetch server current time ─────────────────────────────────────────────
  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-current-datetime/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data?.status === 200 && data?.data) {
          const { current_date, current_time } = data.data;
          setServerCurrentTime(`${current_date}T${current_time}`);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        setServerCurrentTime(new Date().toISOString());
      }
    };
    fetchServerTime();
  }, []);

  // ── getCurrentDateTime: server time + 15 min buffer ──────────────────────
  const getCurrentDateTime = () => {
    const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
    base.setMinutes(base.getMinutes() + 15);
    const year = base.getFullYear();
    const month = String(base.getMonth() + 1).padStart(2, "0");
    const day = String(base.getDate()).padStart(2, "0");
    const hours = String(base.getHours()).padStart(2, "0");
    const mins = String(base.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching courses: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchScopes = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-list-of-scopes`,
          { headers: { accept: "application/json" } }
        );
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        const activeScopes = data.filter((scope) => scope.status === 1);
        setScopes(activeScopes);
      } catch (error) {
        console.error("Error fetching scopes:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching Scopes: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchScopes();
  }, []);

  useEffect(() => {
    const fetchQuestionPaperList = async () => {
      const courseId = courseOpted ? (typeof courseOpted === "object" ? courseOpted.id : courseOpted) : "";
      const classIds = Array.isArray(selectedClass) ? selectedClass : [];
      if (!clientBranchId || !courseId || classIds.length === 0) {
        return;
      }

      const classQuery = classIds.map((id) => `&class_id=${id}`).join("");

      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-list/?branch_id=${clientBranchId}&course_id=${courseId}${classQuery}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        if (result.status === 200) setQuesPaperList(result.data);
      } catch (error) {
        console.error("Error fetching question paper list:", error);
      }
    };
    fetchQuestionPaperList();
  }, [clientBranchId, courseOpted, selectedClass, userName]);

  useEffect(() => {
    if (selectScope !== null) fetchScopeDetails();
  }, [selectScope, courseOpted, selectedSession, selectedClass]);

  const fetchScopeDetails = async () => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-scopes-details-all`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.status === 200) {
        let apiData = data.data;
        const scopeId =
          selectScope && typeof selectScope === "object"
            ? selectScope.id
            : selectScope;
        if (scopeId === 1 && courseOpted) {
          const selectedCourseId =
            typeof courseOpted === "object" ? courseOpted.id : courseOpted;
          apiData = apiData.filter(
            (item) => item.course_id === selectedCourseId
          );
        }
        if (selectedSession)
          apiData = apiData.filter(
            (item) => item.session_name === selectedSession
          );
        let scopeOptions = [];
        switch (scopeId) {
          case 1:
            scopeOptions = apiData.map((item) => ({
              id: item.batch_id,
              label: item.batch_name,
            }));
            break;
          case 2:
            scopeOptions = apiData.map((item) => ({
              id: item.branch_id,
              label: item.branch_name,
            }));
            break;
          case 3:
            scopeOptions = apiData.map((item) => ({
              id: item.city_zone_id,
              label: item.zone_name,
            }));
            break;
          case 4:
            scopeOptions = apiData.map((item) => ({
              id: item.city_id,
              label: item.city_name,
            }));
            break;
          case 5:
            scopeOptions = apiData.map((item) => ({
              id: item.state_id,
              label: item.state_name,
            }));
            break;
          case 7:
          case 8:
            scopeOptions = [{ id: 1, label: "All India" }];
            break;
          case 9:
            scopeOptions = [];
            break;
          default:
            scopeOptions = [];
        }
        scopeOptions = Array.from(
          new Map(scopeOptions.map((opt) => [opt.id, opt])).values()
        );
        setScopeSpecificData(scopeOptions);
      } else {
        setScopeSpecificData([]);
      }
    } catch (error) {
      console.error("Error fetching scope details:", error);
      setScopeSpecificData([]);
    }
  };

  const getScopeLabel = (scopeId) => {
    switch (scopeId) {
      case 1:
        return "Batch";
      case 2:
        return "Branch";
      case 3:
        return "Zone";
      case 4:
        return "City";
      case 5:
        return "State";
      case 7:
        return "All India (Internal)";
      case 8:
        return "All India (Open)";
      case 9:
        return "Group";
      default:
        return "Scope";
    }
  };

  useEffect(() => {
    const fetchTestSeries = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-series-list-by-branch/?client_branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        if (result.status === 200) setTestSeries(result.data);
      } catch (error) {
        console.error("Error fetching test series:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching test series: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    if (clientBranchId) fetchTestSeries();
  }, [clientBranchId]);

  useEffect(() => {
    const fetchMarkingSchemes = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
          { headers: { accept: "application/json" } }
        );
        const result = await response.json();
        if (result.status_code === 200 || result.status === "success")
          setMarkingSchemeList(result.data);
      } catch (error) {
        console.error("Error fetching marking schemes:", error);
      }
    };
    fetchMarkingSchemes();
  }, []);

  useEffect(() => {
    const fetchSessionsAndClasses = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-scopes-details-all/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.status === 200) {
          const apiData = data.data;
          const sessions = Array.from(
            new Set(apiData.map((item) => item.session_name))
          ).map((name) => ({ label: name, id: name }));
          const classes = Array.from(
            new Set(apiData.map((item) => item.class_id))
          ).map((id) => {
            const found = apiData.find((item) => item.class_id === id);
            return { label: found ? found.class_name : id, id: id };
          });
          classes.sort((a, b) => {
            const aNum = parseInt(a.label.replace(/\D/g, ""), 10);
            const bNum = parseInt(b.label.replace(/\D/g, ""), 10);
            if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
            return a.label.localeCompare(b.label, undefined, { numeric: true });
          });
          setSessionOptions(sessions);
          setClassOptions(classes);
        }
      } catch (error) {
        console.error("Error fetching session/class data:", error);
      }
    };
    fetchSessionsAndClasses();
  }, []);

  const searchFaculty = async (searchKey) => {
    if (searchKey.length < 3) return;
    try {
      const token = localStorage.getItem("other");
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-faculty-list/?search_key=${searchKey}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data) setFacultyList(data);
    } catch (error) {
      console.error("Error searching faculty:", error);
    }
  };

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    const fetchTestTemplates = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setTestTemplates(data);
      } catch (error) {
        console.error("Error fetching test templates:", error);
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  useEffect(() => {
    if (selectedQuesPaper !== null) {
      const paperId = parseInt(selectedQuesPaper, 10);
      const matchingPaper = quesPaperList.find(
        (paper) => Number(paper.ques_paper_id) === paperId
      );
      if (matchingPaper) {
        setQuesPaperDescription(matchingPaper.description || "");
        setQuesPaperCreatedBy(matchingPaper.created_by || "");
        const subjectNames = Array.isArray(matchingPaper.subjects)
          ? matchingPaper.subjects.map((s) => s.subject_name)
          : [];
        setTestSeriesSubjects(subjectNames.join(", "));
        const subjectsWithSections = Array.isArray(matchingPaper.subjects)
          ? matchingPaper.subjects.map((subject) => ({
            subject_id: subject.subject_id,
            subject_name: subject.subject_name,
            sections:
              Array.isArray(subject.sections) && subject.sections.length > 0
                ? subject.sections
                : [{ section_no: 1, section_name: "Section 1" }],
          }))
          : [];
        setPaperSubjects(subjectsWithSections);
        const maxSections = subjectsWithSections.reduce(
          (max, subj) => Math.max(max, subj.sections.length),
          1
        );
        setMarkingSchemeCount(maxSections);
        setShowMarkingScheme(maxSections >= 2);
      } else {
        setQuesPaperDescription("");
        setQuesPaperCreatedBy("");
        setTestSeriesSubjects("");
        setPaperSubjects([]);
        setMarkingSchemeCount(1);
        setShowMarkingScheme(false);
      }
    } else {
      setQuesPaperDescription("");
      setQuesPaperCreatedBy("");
      setTestSeriesSubjects("");
      setPaperSubjects([]);
      setMarkingSchemeCount(1);
      setShowMarkingScheme(false);
    }
  }, [selectedQuesPaper, quesPaperList]);

  useEffect(() => {
    setSelectedMarkingSchemes(Array(markingSchemeCount).fill(null));
  }, [markingSchemeCount]);

  const resetDependentFields = () => {
    setTestSeriesDescription("");
    setCourseOpted("");
    setSelectedScope(null);
    setScopeSelection([]);
    setTestMode(1);
    setTestSeriesPrefix("");
    setSelectedClass(null);
    setTime("");
    setTimeMinutes("");
    setSelectedMarkingSchemes({});
    setPaperSubjects([]);
    setMarkingSchemeCount(1);
    setShowMarkingScheme(false);
    setSelectedQuesPaper(null);
    setTestNameUserPart("");
    setTestDescription("");
    setInstructionsHtml("");
    setTestStartDate(null);
    setTestEndDate(null);
    setTestCoordinator(null);
    setNumberOfSets(1);
    setShuffleSubjects(0);
    setShuffleQuestions(1);
    setShuffleOptions(0);
  };

  const handleTestSeriesSelect = (selectedId) => {
    setSelectedTestSeries(selectedId);
    resetDependentFields();
    if (selectedId === 0) {
      return;
    }
    const selectedSeries = testSeries.find((ts) => ts.ts_id === selectedId);
    if (selectedSeries) {
      setTestSeriesDescription(selectedSeries.ts_desc || "");
      setCourseOpted({
        id: selectedSeries.course_id,
        label: selectedSeries.course_name,
      });
      setSelectedScope({
        id: selectedSeries.scope_id,
        label: selectedSeries.scope_name,
      });
      setTestMode(Number(selectedSeries.test_mode));
      setTestSeriesPrefix(selectedSeries.ts_name + "-");
      const subjectSections = selectedSeries.subject_section || [];
      if (subjectSections.length > 0) {
        const subjectMap = {};
        subjectSections.forEach((section) => {
          if (!subjectMap[section.subject_name])
            subjectMap[section.subject_name] = [];
          subjectMap[section.subject_name].push({
            subject_id: section.subject_id,
            subject_name: section.subject_name,
            section_no: section.section_no,
            section_name: section.section_name,
            ms_id: section.ms_id,
            ms_name: section.ms_name,
            ms_desc: section.ms_desc,
            expression: section.expression,
          });
        });
        const formattedPaperSubjects = Object.entries(subjectMap).map(
          ([subjectName, sections]) => ({
            subject_id: sections[0].subject_id,
            subject_name: subjectName,
            sections: sections.map((section) => ({
              section_no: section.section_no,
              section_name: section.section_name,
              ms_id: section.ms_id,
            })),
          })
        );
        setPaperSubjects(formattedPaperSubjects);
        const totalSections = Math.max(
          ...Object.values(subjectMap).map((sections) => sections.length),
          1
        );
        setMarkingSchemeCount(totalSections);
        setShowMarkingScheme(totalSections >= 2);
        const markingSchemeSelections = {};
        Object.values(subjectMap).forEach((sections) => {
          sections.forEach((section, idx) => {
            const key = String.fromCharCode(97 + idx);
            markingSchemeSelections[key] = section.ms_id;
          });
        });
        setSelectedMarkingSchemes(markingSchemeSelections);
        setTestSeriesSubjects(Object.keys(subjectMap).join(", "));
      }
      if (selectedSeries.duration_mins) {
        setTimeMinutes(selectedSeries.duration_mins);
        setTime((selectedSeries.duration_mins / 60).toFixed(2));
      } else {
        setTime("");
        setTimeMinutes("");
      }
      if (
        selectedSeries.class_id_list &&
        Array.isArray(selectedSeries.class_id_list)
      ) {
        const parsedClasses = selectedSeries.class_id_list.map((id) => {
          const match = classOptions.find((cls) => cls.id === id);
          return match || { label: `Class ${id}`, id };
        });
        setSelectedClass(parsedClasses.map((cls) => cls.id));
      }
      const scopeRefIds = selectedSeries.scope_ref_ids || [];
      setFormData((prev) => ({
        ...prev,
        scope_ref_id_list: scopeRefIds.map((opt) => opt.id),
      }));
      setscopeRefNames(
        selectedSeries.scope_ref_ids?.map((item) => item.name).join(", ") || ""
      );
      const scopeId = selectedSeries.scope_id;
      setTimeout(() => {
        switch (scopeId) {
          case 1:
            setSelectedBatch(scopeRefIds);
            break;
          case 2:
            setSelectedBranch(scopeRefIds);
            break;
          case 3:
            setSelectedZone(scopeRefIds);
            break;
          case 4:
            setSelectedCities(scopeRefIds);
            break;
          case 5:
            setSelectedStates(scopeRefIds);
            break;
          case 6:
            setSelectedRegion(scopeRefIds);
            break;
          default:
            break;
        }
      }, 500);
    }
  };

  const handleTestModeChange = (option) => {
    setTestMode(Number(option.id));
  };

  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;
      try {
        setStudentGroupsLoading(true);
        setStudentGroupsError(null);
        const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;
        const resp = await fetch(url, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsError("Not authenticated. Please login.");
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }
        const json = await resp.json();
        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        console.error("Error fetching student groups:", err);
        setStudentGroupsError(err.message || "Error");
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      } finally {
        setStudentGroupsLoading(false);
      }
    };
    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  useEffect(() => {
    setSelectedStudentGroup([]);
  }, [courseOpted]);

  const searchStudentGroups = (searchKey) => {
    const selectedCourseId = courseOpted
      ? typeof courseOpted === "object"
        ? courseOpted.id
        : courseOpted
      : null;
    let filtered = allStudentGroups;
    if (selectedCourseId)
      filtered = filtered.filter((g) => g.course_id === selectedCourseId);
    if (searchKey && searchKey.trim() !== "")
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    setStudentGroupsOptions(filtered);
  };

  const getMinEndDateTime = (startDateTime) => {
    if (!startDateTime) return getCurrentDateTime();
    const startDate = new Date(startDateTime);
    const durationMinutes =
      timeMinutes && parseInt(timeMinutes, 10) > 0
        ? parseInt(timeMinutes, 10)
        : 60;
    const minEndDate = new Date(
      startDate.getTime() + durationMinutes * 60 * 1000
    );
    const year = minEndDate.getFullYear();
    const month = String(minEndDate.getMonth() + 1).padStart(2, "0");
    const day = String(minEndDate.getDate()).padStart(2, "0");
    const hours = String(minEndDate.getHours()).padStart(2, "0");
    const mins = String(minEndDate.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  const handleInputChange = (e) => {
    const minutes = e.target.value;
    setTime((minutes / 60).toFixed(2));
    setTimeMinutes(minutes);
  };

  // ── Free date handlers — no validation here, all validation on SAVE ────────
  const handleStartDateChange = (e) => {
    setTestStartDate(e.target.value);
    // Clear end date if it becomes invalid relative to new start
    if (
      testEndDate &&
      e.target.value &&
      new Date(e.target.value) >= new Date(testEndDate)
    ) {
      setTestEndDate(null);
    }
  };

  const handleEndDateChange = (e) => {
    setTestEndDate(e.target.value);
  };

  const isScopeGroup = (() => {
    const id =
      selectScope && typeof selectScope === "object"
        ? selectScope.id
        : selectScope;
    return Number(id) === 9;
  })();

  const safeScopeIdForLabel =
    selectScope && typeof selectScope === "object"
      ? selectScope.id
      : selectScope;
  const scopeLabel = getScopeLabel(safeScopeIdForLabel);

  useEffect(() => {
    if (isScopeGroup) setScopeSelection([]);
  }, [isScopeGroup]);

  const getFilteredStudentGroups = () => {
    if (!courseOpted) return studentGroupsOptions;
    const selectedCourseId =
      typeof courseOpted === "object" ? courseOpted.id : courseOpted;
    return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
  };

  const handleSave = async () => {
    // ── Validate start date ───────────────────────────────────────────────────
    const minAllowed = getCurrentDateTime(); // server time + 15 min
    if (!testStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a Test Window Start date.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    if (testStartDate < minAllowed) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Test window start must be at least 15 minutes from current time.
              Please correct the start time before saving.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    // ── Validate end date ─────────────────────────────────────────────────────
    if (!testEndDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a Test Window End date.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    if (testEndDate <= testStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Test window end must be after the test window start.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    if (timeMinutes && parseInt(timeMinutes, 10) > 0) {
      const start = new Date(testStartDate);
      const end = new Date(testEndDate);
      const minutesDiff = (end - start) / (1000 * 60);
      const requiredMinutes = parseInt(timeMinutes, 10);
      if (minutesDiff < requiredMinutes) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Test window duration must be at least {requiredMinutes} minutes
                ({(requiredMinutes / 60).toFixed(2)} hours). Please adjust your
                test window.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    // ── Validate question paper ───────────────────────────────────────────────
    if (!selectedQuesPaper) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Question Paper must be selected. Please choose a valid question
              paper.
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const scopeSelectionFilled = Array.isArray(scopeSelection)
      ? scopeSelection.length > 0
      : !!scopeSelection;
    const studentGroupFilled = Array.isArray(selectedStudentGroup)
      ? selectedStudentGroup.length > 0
      : !!selectedStudentGroup;

    if (isScopeGroup) {
      if (!studentGroupFilled) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please select at least one Student Group when Scope is set to
                "Group".
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
        return;
      }
    } else {
      if (!scopeSelectionFilled && !studentGroupFilled) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please select at least one Scope Reference OR a Student Group.
                Both cannot be empty.
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
        return;
      }
    }

    if (
      !testNameUserPart.trim() ||
      !testDescription.trim() ||
      !instructionsHtml.trim() ||
      !testCoordinator
    ) {
      let missingFields = [];
      if (!testNameUserPart.trim()) missingFields.push("Test Name");
      if (!testDescription.trim()) missingFields.push("Description");
      if (!instructionsHtml.trim()) missingFields.push("Instructions");
      if (!testCoordinator) missingFields.push("Test Coordinator");
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Please fill in all required fields: {missingFields.join(", ")}.
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const subjectsPayload = paperSubjects.map((subject) => {
      const marking_scheme = {};
      subject.sections.forEach((section, idx) => {
        const key = String.fromCharCode(97 + idx);
        const msId = selectedMarkingSchemes[key] || 0;
        marking_scheme[`ms_id_sec_${key}`] = msId;
      });
      return {
        subject_id: subject.subject_id,
        subject_name: subject.subject_name,
        marking_scheme: [marking_scheme],
      };
    });

    const scopeId =
      selectScope && typeof selectScope === "object"
        ? selectScope.id
        : selectScope || 0;
    const courseId = courseOpted
      ? typeof courseOpted === "object"
        ? courseOpted.id
        : courseOpted
      : null;
    const batchIds =
      scopeId === 1
        ? scopeSelection.map((s) => (typeof s === "object" ? s.id : s))
        : [];
    const classIds = Array.isArray(selectedClass) ? selectedClass : [];
    const studentGroupIds = Array.isArray(selectedStudentGroup)
      ? selectedStudentGroup
      : selectedStudentGroup
        ? [selectedStudentGroup]
        : [];

    const body = {
      request: {
        ts_id: selectedTestSeries || null,
        ques_paper_scope_id: scopeId,
        ques_paper_id: selectedQuesPaper || 0,
        test_name:
          (testSeriesPrefix ? testSeriesPrefix : "") + testNameUserPart,
        test_desc: testDescription || "",
        test_window_start: testStartDate || "",
        test_window_end: testEndDate || "",
        duration_mins: parseInt(timeMinutes) || 0,
        no_of_sets: numberOfSets || 0,
        test_mode: testMode || 0,
        test_coordnator_emp_id: testCoordinator || 0,
        client_id: clientId || 0,
        client_branch_id: clientBranchId || 0,
        created_by: userName || "",
        instructions_html: instructionsHtml || "",
        scope_ref_id_list: isScopeGroup ? [] : scopeSelection,
        student_group_id_list: studentGroupIds,
        subjects: subjectsPayload,
      },
      payload: {
        user_name: userName || "",
        client_branch_id: clientBranchId ? Number(clientBranchId) : 0,
        screen_event_id: 74,
        screen_id: 76,
        student_id: null,
        batch_id: batchIds.length ? batchIds : null,
        subject_id: null,
        class_id: classIds.length ? classIds : null,
        course_id: courseId ? [courseId] : null,
        session_id: selectedSession ? [selectedSession] : null,
        student_group_id: studentGroupIds.length ? studentGroupIds : null,
      },
    };

    try {
      const token = localStorage.getItem("other");
      const response = await fetch(
        `${FULL_API_BASE_URL}/create-test-schedule-v1/?shuffle_ques=${!!shuffleQuestions}&shuffle_subject=${!!shuffleSubjects}&shuffle_option=${!!shuffleOptions}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        }
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      if (data.status === 400) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{data.message}</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
        return;
      }
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {data.message || "Test schedule created successfully!"}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(SuccessImg);
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Error creating test schedule: {error.message}</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    }
  };

  const toggleBodyVisible = () => setBodyVisible(!bodyVisible);
  const toggleSchedulingVisible = () => setSchedulingVisible(!schedulingVisible);
  const toggleMarkingSchemeVisible = () => setMarkingSchemeVisible(!markingSchemeVisible);
  const toggleUploadAccordion = () => setIsOpenUpload(!isOpenUpload);

  const handleFileUpload = (file) => {
    setUploadedFile(file);
  };

  return (
    <>
      <div className="create-role-container">
        <div className="create-role-container-ques-paper-del">
          <span className="create-role-heading">Quick Test Scheduling</span>
          <div className="cr-header-btn-container">
            <button
              className="cr-cancel-btn"
              onClick={() => navigate(`/cbt_dashboard`)}
            >
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={handleSave}>
              SAVE
            </button>
          </div>
        </div>
        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>TEST INFORMATION</label>
            </div>
            <div className="accordion-btn" onClick={toggleBodyVisible}>
              {bodyVisible ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>
          {bodyVisible && (
            <div className="accordion-content">
              <div className="grid-container">
                <div className="item1">
                  <ReflectDropdown
                    label="Test Series"
                    style={{ width: "100%" }}
                    setSelected={handleTestSeriesSelect}
                    selected={selectedTestSeries}
                    options={[
                      { label: "-None-", id: 0 },
                      ...testSeries.map((ts) => ({
                        label: `${ts.ts_name} / ${ts.course_name}`,
                        id: ts.ts_id,
                      })),
                    ]}
                    isRequired={true}
                  />
                </div>
                <div className="item2" style={{ position: "relative" }}>
                  <InputComponent
                    label="Description"
                    style={{ width: "100%" }}
                    value={testSeriesDescription}
                    isRequired={false}
                    disable={true}
                  />
                </div>
                <div className="item3">
                  <SelectedDropdownValues
                    label="Course"
                    style={{ width: "100%" }}
                    setSelected={setCourseOpted}
                    selected={courseOpted}
                    options={courses.map((course) => ({
                      label: course.course_name,
                      id: course.course_id,
                    }))}
                    isRequired={false}
                    disabled={true}
                  />
                </div>
                <div className="item4">
                  <SelectedDropdownValues
                    label="Session"
                    style={{ width: "100%" }}
                    setSelected={setSelectedSession}
                    options={sessionOptions}
                    isRequired={false}
                    disabled={true}
                  />
                </div>
                <div className="item5">
                  <MultiSelectSearchDropdown3
                    label="Class"
                    width="100%"
                    marginLeft="0"
                    selected={selectedClass}
                    setSelected={setSelectedClass}
                    options={classOptions}
                    isRequired={false}
                    disabled={true}
                  />
                </div>
                <div className="item-001">
                  <DropDown
                    label="Question Paper Name"
                    style={{ width: "100%" }}
                    selected={selectedQuesPaper}
                    setSelected={setSelectedQuesPaper}
                    options={quesPaperList
                      .filter(
                        (qp) =>
                          !selectedTestSeries ||
                          Number(qp.test_series_id) === Number(selectedTestSeries)
                      )
                      .map((qp) => ({
                        label: qp.ques_paper_name,
                        id: qp.ques_paper_id,
                      }))}
                    isRequired={true}
                  />
                </div>
                <div className="item6">
                  <InputComponent
                    label="Question Paper Description"
                    style={{ width: "100%" }}
                    value={quesPaperDescription}
                    isRequired={false}
                    disable={true}
                  />
                </div>
                <div className="item7">
                  <InputComponent
                    label="Subjects"
                    style={{ width: "100%" }}
                    value={testSeriesSubjects}
                    isRequired={false}
                    disable={true}
                    icon={introgativeImgBlue}
                  />
                </div>
                <div className="item8">
                  <InputComponent
                    label="Question Paper Created By"
                    style={{ width: "100%" }}
                    value={quesPaperCreatedBy}
                    isRequired={false}
                    disable={true}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>TEST SCHEDULING</label>
            </div>
            <div className="accordion-btn" onClick={toggleSchedulingVisible}>
              {schedulingVisible ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>

          {schedulingVisible && (
            <div className="accordion-content">
              <div className="grid-container">

                <div className="item1">
                  <div className="col-cs3-5" style={{ width: "100%" }}>
                    <label
                      style={{
                        color: "#6A6A6A",
                        marginBottom: "6px",
                        display: "block",
                      }}
                    >
                      Test Name
                      <span style={{ color: `${Colors.color15}` }}>*</span>
                    </label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #a4a4a4",
                        padding: "8px",
                      }}
                    >
                      {testSeriesPrefix && (
                        <span style={{ color: "gray", marginRight: "5px" }}>
                          {testSeriesPrefix}
                        </span>
                      )}
                      <input
                        type="text"
                        value={testNameUserPart}
                        onChange={(e) => setTestNameUserPart(e.target.value)}
                        placeholder="Enter test name"
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          fontSize: "inherit",
                          color: "#6A6A6A",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="item2">
                  <InputComponent
                    label="Description"
                    style={{ width: "100%" }}
                    value={testDescription}
                    onChange={(e) => setTestDescription(e.target.value)}
                    isRequired={true}
                    disable={false}
                  />
                </div>
                <div className="item10">
                  <DropDown2
                    label="Number of Sets"
                    style={{ width: "100%" }}
                    selected={numberOfSets}
                    setSelected={setNumberOfSets}
                    options={[
                      { id: 1, label: "1" },
                      { id: 2, label: "2" },
                      { id: 3, label: "3" },
                      { id: 4, label: "4" },
                      { id: 5, label: "5" },
                      { id: 6, label: "6" },
                    ]}
                    isRequired={false}
                  />
                </div>
                <div className="item-002">
                  <InputComponent
                    label="Test Window Start"
                    className="date-CB2-3"
                    type="datetime-local"
                    id="testWindowStart"
                    name="testWindowStart"
                    min={getCurrentDateTime()}
                    value={testStartDate || ""}
                    onChange={handleStartDateChange}
                    required
                  />
                </div>
                <div className="item-003">
                  <InputComponent
                    label="Test Window End"
                    type="datetime-local"
                    id="testWindowEnd"
                    name="testWindowEnd"
                    min={
                      testStartDate
                        ? getMinEndDateTime(testStartDate)
                        : getCurrentDateTime()
                    }
                    value={testEndDate || ""}
                    onChange={handleEndDateChange}
                    required
                  />
                </div>
                <div className="item9">
                  <label style={{ marginBottom: "6px", display: "block", color: "GrayText" }}>
                    Duration <span style={{ color: `${Colors.color15}` }}>*</span>
                  </label>
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      placeholder="( In minutes )"
                      type="number"
                      className="time-input2"
                      value={timeMinutes}
                      onChange={handleInputChange}
                      style={{ width: "100%", paddingRight: "50px" }}
                    />
                    <div
                      className="time-display"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "35%",
                        transform: "translateY(-50%)",
                        color: "#888",
                      }}
                    >
                      {time} hr
                    </div>
                  </div>
                </div>
                <div className="item5">
                  <DropDown2
                    label="Shuffle Subjects"
                    style={{ width: "100%" }}
                    selected={shuffleSubjects}
                    setSelected={setShuffleSubjects}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={numberOfSets < 2}
                  />
                </div>
                <div className="item8">
                  <DropDown2
                    label="Shuffle Questions"
                    style={{ width: "100%" }}
                    selected={shuffleQuestions}
                    setSelected={setShuffleQuestions}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={numberOfSets < 2}
                  />
                </div>

                <div className="item11">
                  <DropDown2
                    label="Shuffle Options"
                    style={{ width: "100%" }}
                    selected={shuffleOptions}
                    setSelected={setShuffleOptions}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={true}
                  />
                </div>

                <div className="item12" style={{ gridColumn: "1/4" }}>
                  <TextEditor
                    templates={testTemplates}
                    value={instructionsHtml}
                    setValue={setInstructionsHtml}
                  />
                </div>

              </div>
            </div>
          )}
        </div>
        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>MARKING SCHEME</label>
            </div>
            <div className="accordion-btn" onClick={toggleMarkingSchemeVisible}>
              {markingSchemeVisible ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>
          {markingSchemeVisible && (
            <div className="accordion-content"
              style={{
                padding: "15px",
                color: `${Colors.color1}`,
              }}
            >
              {paperSubjects.map((subject) =>
                subject.sections.map((section, sectionIdx) => {
                  const key = String.fromCharCode(97 + sectionIdx);
                  const selectedId = selectedMarkingSchemes[key];
                  const scheme = markingSchemeList.find(
                    (ms) => ms.ms_id === selectedId
                  );
                  return (
                    <div
                      className="row-cs"
                      key={`${subject.subject_name}-${section.section_no}`}
                      style={{ marginBottom: "12px", fontSize: "14px" }}
                    >
                      <div className="col-cs" style={{ paddingRight: "10px" }}>
                        <div style={{ marginTop: "10px" }}>
                          {subject.subject_name} - Section{" "}
                          {section.section_name}
                        </div>
                      </div>
                      <div className="col-cs" style={{ paddingRight: "10px" }}>
                        <ReflectDropdown
                          style={{ width: "100%", marginLeft: "1%" }}
                          options={markingSchemeList.map((ms) => ({
                            label: ms.ms_name,
                            id: ms.ms_id,
                          }))}
                          selected={selectedId}
                          setSelected={(val) =>
                            setSelectedMarkingSchemes((prev) => ({
                              ...prev,
                              [key]: val,
                            }))
                          }
                        />
                      </div>
                      <div className="col-cs">
                        <div
                          style={{
                            marginTop: "7px",
                            marginBottom: "4px",
                            color: "gray",
                            marginLeft: "3%",
                          }}
                        >
                          {scheme
                            ? `${scheme.expression} ; ${scheme.ms_desc}`
                            : "—"}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
        {/* UPLOAD FILE Section */}
        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>UPLOAD FILE</label>
            </div>
            <div className="accordion-btn" onClick={toggleUploadAccordion}>
              {isOpenUpload ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>
          {isOpenUpload && (
            <div className="accordion-content">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "20px",
                  padding: "15px",
                }}
              >
                <QuickFileUpload label="Select File" onFileSelect={handleFileUpload} />
                <div className="file-upload-instructions" style={{ fontSize: "14px" }}>
                  <p>
                    <strong>Instructions for Uploading:</strong>
                  </p>
                  <p>
                    1. Ensure the file format is <strong>.docx</strong> or{" "}
                    <strong>.doc</strong>. Other formats, including PDFs, are not
                    supported.
                  </p>
                  <p>
                    2. Do not include blank spaces in the file name. Use underscores
                    (_) or hyphens (-) instead.
                  </p>
                  <p>
                    3. Question numbering format: Use hash (#) before the number and
                    dot (.) after the number. Example - #1., #11., #111.
                  </p>
                  <p>4. Always keep one space after the dot (.) in question numbering.</p>
                  <p>
                    5. Option numbering format: Use (@) before the number and enclose
                    it in brackets (). Example - (@1), (@2). Mark correct answers with
                    an asterisk (*). Example - (@*1), (@*4).
                  </p>
                  <p>6. Do not use alphabets like (a, b, c, d) for options.</p>
                  <p>
                    7. Do not use subscript or superscript formatting (e.g., A
                    <sub>2</sub> or A<sup>2</sup> is not allowed). Instead, use the
                    insert equation feature. Example: A=πr^2.
                  </p>
                  <p>
                    8. Adding images/pictures: .emf format is not supported. Use .png
                    or .jpg formats.
                  </p>
                  <p>9. Always keep one blank line between questions and options.</p>
                  <p>
                    10. Word limit on Solution is{" "}
                    <span style={{ fontWeight: "bold" }}>5000</span> characters.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default QuickTestScheduling;